var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{attrs:{"searchTerm":_vm.searchTerm,"placeholder":_vm.placeholder,"id":"search_box","type":"text","dir":"auto"},on:{"input":function($event){_vm.$emit('input', $event.target.value)}}})])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25faff56","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBox.vue
// module id = null
// module chunks = 